import { ActionReducerMapBuilder, createSlice, SliceCaseReducers } from "@reduxjs/toolkit";
import { MachineType } from "operations/schema/schema";
import { asyncQueries, queryBuilder } from "./machine.queries";

// Interface for state
export interface State {
  machines: MachineType[];
  machinesLoading: boolean;
  errors: any;
}

// Interface for store reducers
interface Reducers extends SliceCaseReducers<State> {}

// Interface for store selectors (if necessary)
//interface Selectors {}

// Definition of actual (initial) state
export const initialState: State = {
  machines: [],
  machinesLoading: false,
  errors: {},
};

// Definition of actual reducers
const reducers: Reducers = {};

// Definition of actual selectors
// const selectors: Selectors = {};

const storeBase = createSlice<State, Reducers>({
  name: "createJob",
  initialState,
  reducers,
  extraReducers: (builder: ActionReducerMapBuilder<State>) => {
    queryBuilder(builder);
  },
});

// To be imported and added in store/reducers
export default storeBase.reducer;

// Export all actions created in store, to be used in components
// I.e, if using setOpen defined in examples above, it would look like this
// export const { setOpen } = storeBase.actions;

export const { getMachines } = asyncQueries;
